module.exports = __webpack_public_path__ + "static/media/tournament-builder-icon-large.f29105e7.svg";